import React from 'react';
import Map from '../../components/map/Map';

export default class App extends React.Component {
	constructor(props){
    super(props);
		console.log({props});
		this.state = {
			attractions: JSON.parse(props.data.attractions),
			course: JSON.parse(props.data.course),
			isMedieval: ['medievalCityEn', 'medievalCityNo'].includes(props.data.currentSiteHandle)
		};
  }

	render () {
		const { attractions, course, isMedieval } = this.state;
		return <Map isMedieval={isMedieval} attractions={attractions} course={course} googleMapsLink={course ? course.googleMapsLink : null} />;
	}
}
